import React from 'react'
import { connect } from 'react-redux'
import { Carousel } from 'antd'

import Link from './link'
import Image from "./image";
import {LogoIcon} from "./icons";
import { ga4 } from '../handlers/google-analytic';

const Hero = ({ 
  images = [],
  autoplay = false,
  autoplaySpeed = 5000,
  placeholder,
  isUsePlaceholderSrc = false,
  profileId
}) => (
  <Carousel
    className={'hero-container'}
    autoplay={autoplay}
    autoplaySpeed={autoplaySpeed}
  >
    {
      images.map((item, index) => (
        <div key={index}>
          {
            (typeof item === 'object') ?
              <Link
                to={`/privilege-detail`}
                state={{ privilegeCode: item ? item.privilegeCode : undefined }}
              >
                <div className={'hero-box'}               
                  button_id="Hero_View_Privilege_btn"
                  onClick={() => {
                    ga4.gtag("event", "hero_view", {
                      privilege_name: item.brandName,
                      category: 'hero_banner',
                      trigger: 'hero_view_privilege_btn',
                      profile_id: profileId
                  })}}
                >
                  <Image PlaceholderComponent={
                    <div
                      className={'coupon-wisdom-logo-box with-placeholder'}
                      style={{
                        height: 242,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <LogoIcon svg={{ height: '6em', className: 'coupon-wisdom-logo' }}/>
                    </div>}
                    src={item && item.imgHightLight}
                  />
                </div>
              </Link> :
              <div className={'hero-box'}                   
                button_id="Hero_View_Privilege_btn"
              >
                <Image 
                  src={item}
                  placeholder={placeholder} 
                  PlaceholderComponent={!isUsePlaceholderSrc && (
                    <div
                      className={'coupon-wisdom-logo-box with-placeholder'}
                      style={{
                        height: 242,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                    >
                      <LogoIcon svg={{ height: '6em', className: 'coupon-wisdom-logo' }}/>
                    </div>
                  )}
                />
              </div>
          }
        </div>
      ))
    }
  </Carousel>
)

const mapStateToProps = ({ user }) => {
  return {
  profileId: user.profileId,
}}

export default connect(mapStateToProps)(Hero)
